import React, { memo, SVGProps } from 'react'

export const Standards = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.7718 3.22656C18.7555 3.22656 18.7392 3.22464 18.7219 3.22464H5.27616C5.25888 3.22464 5.24256 3.22464 5.22528 3.22656C3.85536 3.32352 2.80992 4.5168 2.89344 5.84256V18.1123C2.80992 19.4832 3.85536 20.6765 5.2752 20.7744L18.7738 20.7725C20.1437 20.6755 21.1891 19.4822 21.1056 18.1565V5.88672C21.1882 4.51488 20.1427 3.32256 18.7718 3.22656ZM4.3344 18.1574V5.79744C4.29696 5.22048 4.73184 4.71744 5.30592 4.66464H7.05024V19.3354H5.32704C4.74336 19.295 4.29696 18.7872 4.3344 18.1574ZM18.7238 19.3354H8.49024V4.66464H18.6941C19.2682 4.71648 19.703 5.22048 19.6666 5.84256V18.2026C19.704 18.7862 19.2566 19.296 18.7238 19.3354Z"
      fill="currentColor"
    />
    <path
      d="M14.663 15.5405H11.5642C11.1667 15.5405 10.8442 15.863 10.8442 16.2605C10.8442 16.6579 11.1667 16.9805 11.5642 16.9805H14.663C15.0605 16.9805 15.383 16.6579 15.383 16.2605C15.383 15.863 15.0605 15.5405 14.663 15.5405Z"
      fill="currentColor"
    />
    <path
      d="M16.5898 11.28H11.5651C11.1677 11.28 10.8451 11.6026 10.8451 12C10.8451 12.3974 11.1677 12.72 11.5651 12.72H16.5898C16.9872 12.72 17.3098 12.3974 17.3098 12C17.3098 11.6026 16.9872 11.28 16.5898 11.28Z"
      fill="currentColor"
    />
    <path
      d="M11.5651 8.45952H15.8352C16.2326 8.45952 16.5552 8.13696 16.5552 7.73952C16.5552 7.34208 16.2326 7.01952 15.8352 7.01952H11.5651C11.1677 7.01952 10.8451 7.34208 10.8451 7.73952C10.8451 8.13696 11.1677 8.45952 11.5651 8.45952Z"
      fill="currentColor"
    />
  </svg>
))
